/**
 * Per-ward accent colors (one per clan's ground). Shared by the City Map
 * (hex tinting, ward labels) and the Districts page (card accent rail, crest
 * glow) so the two screens always agree on a clan's color. Keyed by
 * districtId — do not duplicate this map elsewhere.
 */
export const DISTRICT_ACCENT: Record<string, string> = {
  'the-docks':      '#6fc3e8', // The Saltbeards — sea-ice blue
  'gallows-row':    '#7d8074', // The Hanged Ones — rope grey, gallows-grim
  'little-italy':   '#a83f3a', // The Osvald Kin — hearth red, old-blood
  'the-foundry':    '#d9822a', // The Emberhands — furnace orange
  'the-ashlands':   '#9c8570', // The Cinderborn — ash and ember
  'blood-alley':    '#c9435f', // The Red Wyrms — lantern crimson
  'dead-mans-pier': '#3f6b5c', // The Widow's Wake — drowned green-black
  'the-heights':    '#d4b869', // The Althing — pale gold, endgame authority
  'old-market':     '#b8ae8e', // The Silvertongues — silver and parchment
  'freightyards':   '#767b82', // The Sledgemen — iron grey
  'gin-mile':       '#d9a441', // The Skald's Chorus — honey gold, mead-hall
  'motor-row':      '#8a7860', // The Keelbreakers — tar and pale wood
};

/** Fallback accent for a districtId this map doesn't (yet) know about. */
const DEFAULT_ACCENT = '#888888';

/** Accent color for a district, with a safe fallback. */
export const districtAccent = (districtId?: string | null): string =>
  (districtId && DISTRICT_ACCENT[districtId]) || DEFAULT_ACCENT;

/** hex ('#rrggbb') → `rgba(r,g,b,alpha)` — used for ward tint fills and glows. */
export function accentRgba(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}
